import { __rest } from "tslib";
import React from 'react';
import DropdownButton from '../../index';
const ComingSoonDropdownButton = (_a) => {
    var { labelComingSoon } = _a, props = __rest(_a, ["labelComingSoon"]);
    return (React.createElement(DropdownButton, Object.assign({ disabled: true }, props), labelComingSoon));
};
export default ComingSoonDropdownButton;
//# sourceMappingURL=ComingSoonDropdownButton.js.map